import React from 'react';
import { Jumbotron } from 'reactstrap';

const JumboBanner = (props) => {
  return (
      <Jumbotron>
        <h2>Exam Postponed?</h2>
        <p className="lead">
        <div>Need more time to study?</div>
        <div>Want something to check seats for you 24/7?</div>
        </p>
        <hr className="my-2" />
        <p>We will notify you via email and text when there is a test opening that you are interested in. No need to download anything. Check this <a href="https://bit.ly/exresrp" target="_blank" rel="noopener noreferrer">Reddit post</a> with comments from people who've been helped! We've already sent over 100,000 seat alerts via texts/emails!
          <div><br/>Our service is free and we're continually updating the features! </div>
          <div>About expiring requests and paid options, there are 2 main reasons: 1) we want to make sure the requests we're checking are up-to-date (over 2,000 requests now) and 2) we need <a href="https://bit.ly/exampatreon" target="_blank" rel="noopener noreferrer">support</a> to pay for the technology costs (costing close to $200/mo and growing). </div>
          <div><br/>Please complete and submit the form. Check your active requests on the <a href="../Requests">Requests</a> page. Unsubscribe via the unsubscribe button in the top right.</div>
        </p>   
      </Jumbotron>
  );
};

export default JumboBanner;